import { Injectable } from '@angular/core';
import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable()
export class HttpsUpgrader implements HttpInterceptor {
	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next.handle(req.clone({
			url: req.url.replace('http://', 'https://')
		}));
	}
}
